import React, { Component } from 'react'
import { withRouter, Route, Redirect, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import  {
  Container,
  Header,
  Image,
  Segment, 
  Grid, 
  List, 
  Icon,
  Form,
  Label
} from 'semantic-ui-react'
import logo from './assets/logo.svg'
import ttl from './assets/ttl.svg'
//--------------------
import Scroll from 'react-scroll'
import GoogleMapReact from 'google-map-react'
import styled from 'styled-components'

// ------------------- 
const StyledSegment = styled(Segment) `
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-height: 100vh;
    margin: 0px !important;
    border: 0px !important;
    border-radius: 0px !important;
    padding: 30px 0 30px 0;
`;

const Marker = ({ text }) => <Label content={text} tag size="large" color="black"/>


const Contact = () =>
    <StyledSegment id="contact">
        <Grid container stackable columns={2} doubling style={{minHeight: "70vh", marginBottom: "100px"}}>
        <Header content="Contact Us" style={{fontFamily: "roboto", fontSize: "35px"}}/>
            <Grid.Column style={{padding: "30px"}}>
                <GoogleMapReact
                    style={{minHeight: "300px"}}
                    defaultCenter={{
                        lat: 13.038715, 
                        lng: 77.572995
                    }}
                    defaultZoom={17}
                >
                    <Marker
                        lat={13.038715}
                        lng={77.572995}
                        text={'iDNA Media Labs'}
                    />
                </GoogleMapReact>
            </Grid.Column>
            <Grid.Column style={{padding: "30px"}}>
                <Grid style={{margin: "30px 0 30px 0"}}>
                    <Grid.Row style={{paddingBottom: "0px"}}>
                        <Grid.Column width={3} style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                            <Icon name="map" centered size="huge" color="violet"/>
                        </Grid.Column>
                        <Grid.Column width={13} style={{display: "flex", alignItems: "center", justifyContent: "left"}}>
                            <Header as="h3" color="violet" content="#9, 3rd Floor, Maruthi Nilaya, NagashettyHalli, Bangalore, Karnataka - 560094"/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row style={{paddingBottom: "0px"}}>
                        <Grid.Column width={3} style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                            <Icon name="phone" centered size="huge" color="purple"/>
                        </Grid.Column>
                        <Grid.Column width={13} style={{display: "flex", alignItems: "center", justifyContent: "left"}}>
                            <Header color="purple" as="h3" href="tel:+917899884888" content="+91-789-988-4888"/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row style={{paddingBottom: "0px"}}>
                        <Grid.Column width={3} style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                            <Icon name="mail" centered size="huge" color="pink"/>
                        </Grid.Column>
                        <Grid.Column width={13} style={{display: "flex", alignItems: "center", justifyContent: "left"}}>
                            <Header as="h3" color="pink" href="mailto:info.admin@idnamedialabs.com" content="info.admin@idnamedialabs.com"/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid> 
                <Form size="large">
                    <Form.Input label='Name' placeholder='Full Name' />
                    <Form.Input label='Phone' placeholder='Phone Number' />
                    <Form.Input label='Email' placeholder='Email Address' />
                    <Form.TextArea label='Message' placeholder='Message' />
                    <div style={{textAlign: "center"}}><Form.Button color="green">Submit</Form.Button></div>
                </Form>
            </Grid.Column>
        </Grid>
    </StyledSegment>

// ------------------------EOF

const Footer = () => 
<Segment inverted vertical style={{ padding: '1em 4em' }}>
    <Grid container divided stackable={true}>
        <Grid.Row>
            <Grid.Column width={3}>
            <Header inverted as='h4' content='Site' />
            <List link inverted>
                <List.Item as={Scroll.Link} to="about" smooth duration={1000}>About</List.Item>
                <List.Item as={Scroll.Link} to="products" smooth duration={1000}>Products</List.Item>
                <List.Item as={Scroll.Link} to="contact" smooth duration={1000}>Contact</List.Item>
              </List>
            </Grid.Column>
            <Grid.Column width={3}>
            <Header inverted as='h4' content='Services' />
            <List link inverted>
                <List.Item as="a">Services</List.Item>
                <List.Item as="a">Careers</List.Item>
                <List.Item as="a">Blog</List.Item>
            </List>
            </Grid.Column>
            <Grid.Column width={2} href="https://terracetechlabs.com">
                <Header as='h4' inverted>Built with <Icon name="heart" color="red"/></Header>
                <Image src={ttl} size="tiny"/>
            </Grid.Column>
        </Grid.Row>
    </Grid>
</Segment>

const Home = () => 
<Container textAlign="center" style={{display: "flex", minHeight: "100vh", alignItems: "center", justifyContent: "center", flexDirection: "column"}}>
  <Image src={logo} size="medium"/>
  <Header content="iDNA Media Labs" style={{fontFamily: "indie flower", fontSize: "40px"}}/>
  <Header content="Coming Soon!" style={{fontFamily: "indie flower", fontSize: "30px"}}/>
  {/* <Contact />
  <Footer /> */}
  <p>
   </p>
   <p>
       </p>
  <a href="https://terracetechlabs.com" target="_blank">
  <Header as='h4'>Built with <Icon name="heart" color="red"/></Header>
  <Image src={ttl} size="tiny"/>
  </a>
</Container>

// Private Route Handler
const PrivateRoute = withRouter(connect(
  (state) => {
    return {
      user: state.auth.user
    }
  },
  (dispatch) => {
    return {

    }
  }
)(({component: Component, ...rest, user}) => <Route {...rest}
    render={
      props => user ? <Component {...props}/>
        :
      <Redirect
        to={{
          pathname: '/login',
          state: {
            from: props.location
          }
        }}
      />
    }
  />
))

class App extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={Home}/>
        <Redirect to="/"/>
      </Switch>
    )
  }
}

export default withRouter(connect(
    (state) => {
        return {
            user: state.auth.user
        }
    },
    (dispatch) => {
        return {

        }
    }
)(App))



// WEBPACK FOOTER //
// ./src/App.js